export default __webpack_public_path__ + "static/media/parking.inline.21ab49b6.svg";